import cn from 'classnames';

import i18n from 'i18n/config';
import { inrConversionRateSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import Box from 'UIKit/Box';

import ConversionPopover from './ConversionPopover';
import styles from './conversionRate.module.scss';

const conversionRateLabel = i18n.t('headerFooter:header.wallet.conversionRate');

const ConversionRate = ({ className = '' }: { className?: string }) => {
  const inrConversionRate = useAppSelector(inrConversionRateSelector);

  return (
    <Box className={cn(styles.container, className)}>
      <Box flex="flex">
        <Box as="span">{conversionRateLabel}: </Box>
        <Box as="span" className={styles.highlight}>
          1 USD = INR {inrConversionRate}
        </Box>
        <ConversionPopover />
      </Box>
    </Box>
  );
};

ConversionRate.displayName = 'ConversionRate';

export { ConversionRate };
